module.exports = __webpack_public_path__ + "static/media/crsnsp.9491faa0.jpeg";